// extracted by mini-css-extract-plugin
export default {"dragzone":"Style_dragzone__a20Gz","dragging":"Style_dragging__YnpGw","fileTable":"Style_fileTable__Z1P+1","notarget":"Style_notarget__iCaDY","btnExecute":"Style_btnExecute__5YhV-"};